import * as React from "react";

import lablogo from '../assets/images/stibee-logo@2x.png';

function SiteHeader() {

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <h1 className="logo">
          <a href="/">
            <img src={lablogo} alt="stibee 실험실" />{" "}
            <span>실험실</span>
          </a>
        </h1>
        <h2 className="stibee-logo">
          <a href="https://stibee.com" target="_blank">
            스티비 바로가기
          </a>
        </h2>
      </div>
    </header>
  );
}

export default SiteHeader;